export const defaultLocale = 'en';
export const supportedLocales = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
};
export const documentationLocales = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
};
//# sourceMappingURL=supportedLocales.js.map